"use client";

// Eligibility revenue card — Figma 8301:73193 / inset 8301:73195.

import { useLocale } from "next-intl";

import { RevenueMetricPanelCard } from "@/components/cards/metric-panel/metric-panel-card";
import {
  CriterionCardFrame,
  CriterionCardTitle,
} from "@/components/cards/shared/criterion-frame";
import { localizeCurrencyString } from "@/lib/localize-currency";

export function RevenueCriterionCard({ title }: { title?: string }) {
  const locale = useLocale();
  const revenueTitle = localizeCurrencyString(
    title ?? "Makes more than $10,000 a month",
    locale
  );

  return (
    <CriterionCardFrame data-testid="eligibility-revenue-card">
      <CriterionCardTitle
        className="max-w-[169.667px]"
        lines={
          title
            ? [[{ text: revenueTitle }]]
            : [
                [
                  { text: "Makes more than ", muted: true },
                  { text: localizeCurrencyString("$10,000 a month", locale) },
                ],
              ]
        }
      />

      <div className="absolute top-[99px] left-[9.33px] origin-top-left scale-[0.65]">
        <RevenueMetricPanelCard className="h-[291px] w-[391px]" />
      </div>
    </CriterionCardFrame>
  );
}
